document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on the homepage
  const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index';

  // Only run this script on the homepage
  if (!isHomePage) return;

  // Function to swap the logo based on screen width
  function swapLogoIfNeeded() {
    const viewportWidth = window.innerWidth;
    const headerHeading = document.querySelector('.header__heading');
    const homepageLogoWrapper = document.querySelector('.header__heading-logo-wrapper');

    // Only proceed if we found the homepage logo wrapper
    if (!homepageLogoWrapper || !headerHeading) return;

    // If viewport width is less than 990px, swap to the other pages' logo
    if (viewportWidth < 990) {
      // Check if we've already swapped the logo (to avoid unnecessary DOM operations)
      if (!headerHeading.classList.contains('mobile-logo-active')) {
        // Add mobile logo classes to the header heading
        headerHeading.classList.add('mobile-logo-active');

        // Create the new logo structure that matches the other pages
        const newLogoHTML = `
          <div class="header-nav-logo mobile-homepage-logo">
            <a href="/" class="header-nav-logo-link">
              <img src="https://cdn.shopify.com/s/files/1/0717/3380/5285/files/header-logo-light.svg?v=1741909738" 
                   alt="Yipp Yapp" 
                   class="header-nav-logo-image">
            </a>
          </div>
        `;

        // Replace the content of the logo wrapper
        homepageLogoWrapper.innerHTML = newLogoHTML;

        // Add styles to fix sizing and positioning
        homepageLogoWrapper.style.width = 'auto';
        homepageLogoWrapper.style.height = 'auto';
      }
    } else {
      // If viewport width is 990px or greater, restore the original logo if needed
      if (headerHeading.classList.contains('mobile-logo-active')) {
        // Remove mobile logo classes
        headerHeading.classList.remove('mobile-logo-active');

        // Restore the original homepage logo
        homepageLogoWrapper.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0717/3380/5285/files/Site_Logo_Transparent.png" width="150">';

        // Reset inline styles
        homepageLogoWrapper.style.width = '';
        homepageLogoWrapper.style.height = '';
      }
    }
  }

  // Run the function on page load
  swapLogoIfNeeded();

  // Also run the function when the window is resized
  window.addEventListener('resize', swapLogoIfNeeded);
});
